<template>
    <div class="template-message-selector">
        <div class="title">{{ $t("whatsapp_business_api.selectATemplate") }}</div>
        <div class="d-flex gap-5">
            <a-select v-model="selectedTemplateId" style="width: 100%" placeholder="Select a template message">
                <a-select-option v-for="template in templates" :key="template.id" :value="template.id">
                    {{ template.elementName }}
                </a-select-option>
            </a-select>
            <a-spin v-if="loading">
                <a-icon slot="indicator" type="loading" style="font-size: 24px" spin />
            </a-spin>
        </div>

        <a-divider />
        <TemplateCard :template="selectedTemplate" v-if="!!selectedTemplate" />
        <a-divider v-if="variables.length" />
        <div class="variables-container" v-if="variables.length">
            <label>{{ $t("whatsapp_business_api.variableSettings") }}</label>
            <div class="variables">
                <div class="variable" v-for="(variable, i) of variables">
                    <label>{{ $t("whatsapp_business_api.variable") }} {{ i + 1 }} ==> </label>

                    <a-select
                        v-model="variables[i]"
                        style="width: 100%"
                        placeholder="Select a variable"
                        v-if="fieldMode"
                    >
                        <a-select-option v-for="v in getAvailableParameters()" :key="v.id" :value="v.id">
                            {{ v.label }}
                        </a-select-option>
                    </a-select>
                    <a-select v-model="variables[i]" style="width: 100%" placeholder="Select a variable" v-else>
                        <a-select-option v-for="v in getAvailableParameters()" :key="v" :value="v">
                            {{ v }}
                        </a-select-option>
                    </a-select>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import { mapActions, mapState } from "vuex";
import _ from "lodash";
import TemplateCard from "../../../../WhatsappBusiness/detail/TemplateCard.vue";
import log2 from "../../../../../../utils/log2";
import WHATSAPP_API from "../../../../../../api/whatsapp";

const log = log2("TemplateMessageSelector.vue");
export default Vue.extend({
    name: "TemplateMessageSelector",
    components: { TemplateCard },
    props: {
        channelId: {
            type: String,
            required: true,
        },
        value: {
            required: true,
        },
        fieldMode: {
            type: Boolean,
            default: false,
        },
        defaultFields: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            loading: false,
            selectedTemplateId: null,
            selectedTemplate: null,
            clone: _.cloneDeep(this.value),
            variables: _.cloneDeep(this.value?.templateParams || []),
            selectedCustomerGroup: null,
            templates: [],
        };
    },
    computed: {
        ...mapState({
            socketConnected: (state) => state.socketStatus.socket_connected,
            site: (state) => state.site.site,
        }),
    },
    methods: {
        ...mapActions({
            getTemplates: "whatsapp/getTemplates",
        }),
        getCustomerGroupDetail() {
            if (this.value.groupId) {
                WHATSAPP_API.BROADCAST.getGroupById(this.value.groupId).then((res) => {
                    this.selectedCustomerGroup = res.data;
                });
            }
        },
        getAvailableParameters() {
            if (this.fieldMode) {
                return this.defaultFields;
            }
            if (this.selectedCustomerGroup) {
                const headContactAttributes = _.get(this.selectedCustomerGroup, "contacts.0.attributes", {}) || {};
                return Object.keys(headContactAttributes);
            }
            return [];
        },
        getParams(template) {
            const templateType = template.templateType;
            const containerMetaObj = JSON.parse(template.containerMeta);
            const headerText = _.get(containerMetaObj, "header", "");
            let cardVariableSize = 0;
            if (templateType === "CAROUSEL") {
                const cards = containerMetaObj.cards;
                cardVariableSize = cards.map((card) => {
                    return card.body.match(/{{\d+}}/g);
                }).flat().length;
            }
            return [
                ..._.uniq(headerText.match(/{{\d+}}/g)),
                ..._.uniq(template.data.match(/{{\d+}}/g)),
                ...new Array(cardVariableSize).fill(null),
            ].map(() => "");
        },
    },
    mounted() {
        this.getCustomerGroupDetail();
        this.getTemplates(this.channelId).then((templates) => {
            this.templates = templates;
            this.selectedTemplateId = this.templates[0]?.id;
        });
    },
    watch: {
        selectedTemplateId(val) {
            this.selectedTemplate = this.templates.find((x) => x.id === val);
            this.variables = this.getParams(this.selectedTemplate);
            this.clone.selectedTemplate = this.selectedTemplate;
        },
        clone: {
            handler: function(val) {
                if (val) {
                    const isChanged = !_.isEqual(val, this.value);
                    if (isChanged) {
                        log("clone changed=>", val);
                        this.$emit("input", val);
                    }
                }
            },
            deep: true,
        },
        variables: {
            handler: function(val) {
                if (val) {
                    const isChanged = !_.isEqual(val, this.value.templateParams);
                    log("variables changed=>", { val, isChanged, old: this.value.templateParams });
                    if (isChanged) {
                        log("variables changed=>", val);
                        this.clone.templateParams = val;
                    }
                }
            },
            deep: true,
        },
    },
});
</script>

<style scoped lang="scss">
.variables-container {
    display: flex;
    flex-direction: column;
    gap: 10px;

    label {
        font-weight: bold;
    }

    .variables {
        display: flex;
        flex-direction: column;
        gap: 5px;

        .variable {
            display: flex;
            gap: 5px;
            align-items: center;
            max-width: 500px;

            label {
                font-weight: bold;
                width: 150px;
            }
        }
    }
}
</style>
